import Vue from 'vue';

Vue.filter('dateOnly', input => input.split('T')[0].trim());
